import {TIPOSIMULACIONDISTRIBUIDOR} from "../../Constantes";

export const obtenerComisionDistribuidor = (datos, usuario) => {


    let dox = {}

    switch (datos.tipo) {
        case TIPOSIMULACIONDISTRIBUIDOR[0].nombre: //Venta Directa
            dox = ventaDirecta(datos)
            break
        case TIPOSIMULACIONDISTRIBUIDOR[1].nombre: //Venta Hijo
            dox = ventaHijo(datos)
            break
        case TIPOSIMULACIONDISTRIBUIDOR[2].nombre: //Venta Nieto
            dox = ventaNieto(datos)
            break
    }


    return dox;

}


const ventaDirecta = (datos) => {

    let comisionVenta = 50


    let impuesto = datos.impuesto

    let valorSinImpuesto = (datos.valor / ((impuesto / 100) + 1))
    let valorComisionVenta = obtenerValorPorcentaje(comisionVenta, valorSinImpuesto)


    return {
        impuesto: impuesto,
        valorImpuesto: datos.valor - valorSinImpuesto,
        valorSinImpuesto: valorSinImpuesto,
        valorComisionVenta: valorComisionVenta,
        valorComisionConsultor: 0,
        valorRecaudoDistribuidor: 0,
        valorBodega: datos.valorBodega,
        valor: datos.valor,
        valorAjuste: datos.valor - (valorComisionVenta + datos.valorBodega + (datos.valor - valorSinImpuesto)),
        valorComisionHijo: 0,
        valorComisionNieto: 0

    }

}

const ventaHijo = (datos) => {


    let comisionVenta = 25


    let impuesto = datos.impuesto

    let valorSinImpuesto = (datos.valor / ((impuesto / 100) + 1))
    let valorComisionVenta = obtenerValorPorcentaje(comisionVenta, valorSinImpuesto)
    let valorComisionHijo = obtenerValorPorcentaje(20, valorSinImpuesto)


    return {
        impuesto: impuesto,
        valorImpuesto: datos.valor - valorSinImpuesto,
        valorSinImpuesto: valorSinImpuesto,
        valorComisionVenta: valorComisionVenta,
        valorComisionConsultor: 0,
        valorRecaudoDistribuidor: 0,
        valorBodega: datos.valorBodega,
        valor: datos.valor,
        valorAjuste: datos.valor - (valorComisionVenta + datos.valorBodega + (datos.valor - valorSinImpuesto) + valorComisionHijo),
        valorComisionHijo: valorComisionHijo,
        valorComisionNieto: 0

    }

}

const ventaNieto = (datos) => {


    let comisionVenta = 25


    let impuesto = datos.impuesto

    let valorSinImpuesto = (datos.valor / ((impuesto / 100) + 1))
    let valorComisionVenta = obtenerValorPorcentaje(comisionVenta, valorSinImpuesto)
    let valorComisionHijo = obtenerValorPorcentaje(5, valorSinImpuesto)
    let valorComisionNieto = obtenerValorPorcentaje(20, valorSinImpuesto)

    return {
        impuesto: impuesto,
        valorImpuesto: datos.valor - valorSinImpuesto,
        valorSinImpuesto: valorSinImpuesto,
        valorComisionVenta: valorComisionVenta,
        valorComisionConsultor: 0,
        valorRecaudoDistribuidor: 0,
        valorBodega: datos.valorBodega,
        valor: datos.valor,
        valorAjuste: datos.valor - (valorComisionVenta + datos.valorBodega + (datos.valor - valorSinImpuesto) + valorComisionHijo + valorComisionNieto),
        valorComisionHijo: valorComisionHijo,
        valorComisionNieto: valorComisionNieto
    }

}


function obtenerValorPorcentaje(porcentaje, total) {
    return (porcentaje / 100) * total;
}